import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useUID } from 'dibs-uid';
import { SeoLink } from 'dibs-seo/exports/SeoLink';
import slugify from 'dibs-slugify/exports/slugify';
import HpLazyImageWrapper from '../HpLazyImageWrapper/HpLazyImageWrapper';
import ResponsiveImage from '../ResponsiveImage';

import styles from './HpRespFeaturedModuleItem.scss';

function HpRespFeaturedModuleItem({ item, onClick, useLazyLoadImages }) {
    const uid = useUID() || undefined;
    const { title = '', linkData, imageUrl, cta } = item || {};
    const linkId = slugify(`${item.title}-${uid}`);

    return (
        <div className={classnames(styles.item, 'colXs6')}>
            <SeoLink className={styles.link} linkData={linkData} onClick={onClick}>
                <span id={linkId} className={styles.title}>
                    {title}
                </span>
                <HpLazyImageWrapper
                    useLazyLoad={useLazyLoadImages}
                    className={styles.imageContainer}
                >
                    <ResponsiveImage
                        className={styles.image}
                        ariaLabelledBy={title ? linkId : undefined}
                        src={imageUrl}
                        srcSetWidths={[100, 120, 150]}
                    />
                </HpLazyImageWrapper>
                <span className={styles.cta}>{cta}</span>
            </SeoLink>
        </div>
    );
}

HpRespFeaturedModuleItem.propTypes = {
    item: PropTypes.shape({
        imageUrl: PropTypes.string,
        cta: PropTypes.string,
        title: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    useLazyLoadImages: PropTypes.bool,
    onClick: PropTypes.func,
};

HpRespFeaturedModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespFeaturedModuleItem };
